import React, { useState } from "react";

import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { checkIfTargetValueIsANumberAndReturnCurrentValueIfNot } from "Utils/formUtils";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import { ConstructionYearError } from "./ConstructionYearError";

export interface ConstructionYearValue {
  constructionYear: string;
}

export interface Props<T extends ConstructionYearValue> {
  formProps: FormikProps<T>;
  label: string;
  hint: string;
  errorMessage: string;
  disabled?: boolean;
}

export const ConstructionYear = <T extends ConstructionYearValue>({
  formProps,
  label,
  hint,
  errorMessage,
  disabled = false,
}: Props<T>): React.ReactElement => {
  const [input, setInput] = useState("");

  return (
    <>
      <Input
        large
        id="constructionYear"
        name="constructionYear"
        label={label}
        hint={hint}
        error={getError("constructionYear", formProps)}
        onChange={(e) => {
          e.target.value =
            checkIfTargetValueIsANumberAndReturnCurrentValueIfNot(
              input,
              e.target.value,
              formProps.values.constructionYear,
            );
          setInput(e.target.value);
        }}
        inputProps={{ maxLength: 4 }}
        disabled={disabled}
        inputMode={InputMode.NUMERIC}
      />
      <ConstructionYearError
        formProps={formProps}
        errorMessage={errorMessage}
        marginBottom="24px"
      />
    </>
  );
};
